//import { transformNullishFromData } from "@/utils/transforms";

export default {
  state: {
    default: null,
    data: null,
  },

  getters: {
    getMenuData(state) {
      return state.data;
    },

    getDefaultMenuData(state) {
      return state.default;
    }
  },

  mutations: {
    setMenuData(state, data) {
      if (typeof data == 'object' && data !== null) {
        state.data = data;
        return;
      }

      state.data = data;
    },
  },

  actions: {
    changeMenuData({ commit }, data) {
      commit("setMenuData", data);
    }
  },
};
